import * as React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.earnedBonus');
  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">
            {tt('title', 'Earned Quick Start Bonus')}
          </Text>
        </Gutter>
      </View>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('earnedOn', 'Earned on')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxEarnedOn} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={
            <Text>{tt('fqvDuringCabPeriod', 'FQV during QSB Period')}</Text>
          }
          suffix={<LoadingBox style={styles.loadingBoxFqv} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={
            <Text>
              {tt('totalNewOrderingEntities', 'Total New Ordering Entities')}
            </Text>
          }
          suffix={<LoadingBox style={styles.loadingBoxNew} />}
        />
      </Gutter>
    </View>
  );
};
